import React from "react";

const TableProductSell = ({tableData, currentPage}) => {
  let startNumber = 1;

  if (currentPage !== 1) {
    startNumber = (currentPage - 1) * 15 + 1;
  }

  return (
    <table className="font-nunito-sans text-xs w-full overflow-y-auto relative">
      <thead className="sticky top-0">
        <tr className="bg-[#F9F9FC] text-black text-left">
          <th className="py-2 text-center whitespace-nowrap">No</th>
          <th className="py-2 text-center whitespace-nowrap">Date</th>
          <th className="py-2 text-center whitespace-nowrap">Transaction ID</th>
          <th className="py-2 text-center whitespace-nowrap">Product ID</th>
          <th className="py-2 text-center whitespace-nowrap">Category</th>
          <th className="py-2 text-center whitespace-nowrap">Product Name</th>
          <th className="py-2 text-center whitespace-nowrap">Price</th>
          <th className="py-2 text-center whitespace-nowrap">Commission</th>
          <th className="py-2 text-center whitespace-nowrap">Total</th>
        </tr>
      </thead>
      <tbody>
        {tableData.length > 0 &&
          tableData.map((row) => (
            <tr key={row.id} className="even:bg-[#F9F9FC] text-black">
              <td className="py-4 text-center whitespace-nowrap">{startNumber++}</td>
              <td className="py-2 text-center whitespace-nowrap">{row.datetime}</td>
              <td className="py-2 text-center whitespace-nowrap">{row.transaction_code}</td>
              <td className="py-2 text-center whitespace-nowrap">{row.product_code}</td>
              <td className="py-2 text-center whitespace-nowrap">{row.category_name}</td>
              <td className="py-2 text-center whitespace-nowrap">{row.product_name}</td>
              <td className="py-2 text-right whitespace-nowrap">{row.price}</td>
              <td className="py-2 text-right whitespace-nowrap">{row.total_fee}</td>
              <td className="py-2 text-right whitespace-nowrap">{row.profit}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default TableProductSell;